<app-auth-shell-background />

<div class="app-content">
    <app-auth-logo />

    <router-outlet />
</div>

<p class="copyright" *ngIf="isEvaranBranding; else careLineLiveCopyright">
    Copyright &copy; {{ year }} <a href="https://evaran.com/" target="_blank">Evaran</a>. All rights reserved.
</p>
<ng-template #careLineLiveCopyright>
    <p class="copyright">
        Copyright &copy; {{ year }} <a href="https://carelinelive.com/" target="_blank">CareLineLive</a>.
        Part of <a href="https://www.mas-group.co.uk/" target="_blank">MAS Group</a>. All rights reserved.
    </p>
</ng-template>
